import { Component } from '@angular/core';
import { KeycodeService } from './../../services/keycode.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-keycode',
  templateUrl: './keycode.component.html',
  styleUrls: ['./keycode.component.scss'],
})
export class KeycodeComponent {
  constructor(private keycodeServ: KeycodeService) {}
  visible: boolean = false;
  value: string = '';
  Code: any;
  keycodes: any[] = [];
  selectedcode: any;

  ngOnInit() {
    this.LoadData();
  }

  LoadData() {
    this.keycodeServ.getData().subscribe((res) => {
      console.log(res);
      this.keycodes = res;
    });
  }

  onClickAdd() {
    this.visible = true;
  }

  Update() {
    if (this.Code == null) {
      Swal.fire({
        icon: 'warning',
        title: 'NOTICE',
        text: 'Fill-up all fields',
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      let data = {
        code: this.selectedcode,
        newcode: this.Code,
      };
      this.keycodeServ.Update(data).subscribe((res: any) => {
        // console.log(res);
        if (res.flag == 1) {
          Swal.fire({
            icon: 'success',
            title: 'SUCCESS',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.LoadData();
          this.visible = false;
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'NOTICE',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    }
  }

  ShowModal(Code: any) {
    this.visible = true;
    this.selectedcode = Code;
  }
  Save() {
    if (this.Code == null) {
      Swal.fire({
        icon: 'warning',
        title: 'NOTICE',
        text: 'Fill-up all fields',
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      let data = {
        code: this.Code,
        // name: this.Name,
      };
      this.keycodeServ.Add(data).subscribe((res: any) => {
        // console.log(res);
        if (res.flag == 1) {
          Swal.fire({
            icon: 'success',
            title: 'SUCCESS',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.LoadData();
          this.visible = false;
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'NOTICE',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    }
  }
}
